import React, { useState } from 'react';
import './style.scss';
import { HoverText } from '../../shared/TextFx';
import { useModal } from '../../shared/ModalContext';

/**
 * Stand-in for the `#modal-contact` / `#modal-thx` Fancybox popups the
 * source JS calls — that markup was never present in the uploaded HTML,
 * so this rebuilds it as a plain React-controlled modal using the
 * `.modal` / `.modal.hidden` classes already defined in global.scss.
 * Triggered from Header's "Contact Us" button and ContactSec's
 * "Leave a request" button via ModalContext.
 */
const ContactModal = () => {
  const { status, closeModal, showThanks } = useModal();
  const [form, setForm] = useState({ fullName: '', phone: '' });

  if (status === 'closed') return null;

  const handleChange = (field) => (e) => setForm((prev) => ({ ...prev, [field]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    showThanks();
  };

  return (
    <div className="modal-overlay" onClick={closeModal}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <button aria-label="Close" className="modal__form-close" onClick={closeModal} type="button">
          ×
        </button>

        {status === 'form' && (
          <>
            <h3 className="modal__title">Leave a request</h3>
            <p className="modal__text">We will call you back shortly.</p>
            <form className="modal__form" onSubmit={handleSubmit}>
              <label className="contact__form-item input">
                <span className="contact__form-caption input__caption">
                  Full name: <span className="_c-accent">*</span>
                </span>
                <input
                  className="contact__form-input input__field"
                  onChange={handleChange('fullName')}
                  required
                  type="text"
                  value={form.fullName}
                />
              </label>
              <label className="contact__form-item input">
                <span className="contact__form-caption input__caption">
                  Phone number: <span className="_c-accent">*</span>
                </span>
                <input
                  className="contact__form-input input__field input-tel"
                  onChange={handleChange('phone')}
                  required
                  type="tel"
                  value={form.phone}
                />
              </label>
              <button className="modal__form-submit text-hover btn _accent" type="submit">
                <span className="text-hover__inner">
                  <HoverText words="Send a request" />
                </span>
              </button>
            </form>
          </>
        )}

        {status === 'thanks' && (
          <div className="modal__thanks">
            <h3 className="modal__title">Thank you!</h3>
            <p className="modal__text">Your request has been received — we'll be in touch shortly.</p>
            <button className="modal__form-close-btn btn" onClick={closeModal} type="button">
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactModal;
